import React from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { Header } from './Header';
import styles from './HeaderClosable.module.scss';

type HeaderClosableProps = {
  to: string;
  closeAriaLabel?: string;
};

export function HeaderClosable({ to, closeAriaLabel }: HeaderClosableProps) {
  const intl = useIntl();
  const ariaLabel = closeAriaLabel || intl.formatMessage({ id: 'common.close', defaultMessage: 'Close' });

  return (
    <div className={styles.closableWrapper}>
      <Header urlsOverride={{}} />

      <IconButton
        component={Link}
        to={to}
        aria-label={ariaLabel}
        size="large"
        sx={{
          position: 'absolute',
          top: '50%',
          right: '16px',
          transform: 'translateY(-50%)',
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>
    </div>
  );
}

HeaderClosable.defaultProps = {
  closeAriaLabel: undefined,
};
